import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { Component, Inject, OnInit } from '@angular/core';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-reset-confirmation',
  templateUrl: './reset-confirmation.component.html',
  styleUrls: ['./reset-confirmation.component.scss']
})
export class ResetConfirmationComponent implements OnInit {

  constructor(
    public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { message: string, title: string, button?: string }
    ) { }

  ngOnInit(): void {
  }

  close() {
    this.modalComponentRef.close();
  }

  reset() {
    this.modalComponentRef.close('reset');
  }

}
